import { type FC } from 'react';
import { TextInput, CopyButton, Tooltip, ActionIcon, type MantineSize } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';

type CopyInputProps = {
    value: string;
    label?: string;
    size?: MantineSize;
};

export const CopyInput: FC<CopyInputProps> = ({ value, label, size = 'sm' }) => {
    return (
        <TextInput
            w='100%'
            maw={300}
            miw={0}
            readOnly
            label={label}
            size={size}
            value={value}
            rightSection={
                <CopyButton
                    value={value}
                    timeout={2000}
                >
                    {({ copied, copy }) => (
                        <Tooltip
                            label={copied ? 'Скопировано' : 'Скопировать'}
                            withArrow
                            position='right'
                        >
                            <ActionIcon
                                color={copied ? 'teal' : 'gray'}
                                variant='subtle'
                                aria-label={copied ? 'Скопировано' : 'Скопировать'}
                                onClick={copy}
                            >
                                {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                            </ActionIcon>
                        </Tooltip>
                    )}
                </CopyButton>
            }
        />
    );
};
